import cx from 'classnames'
import Image from 'next/image'

import SCLogo from 'assets/images/logos/supercell-id-black.svg'

import styles from './PoweredBy.module.scss'

interface PoweredByProps {
  className?: string | string[]
}

export const PoweredBy: React.FC<PoweredByProps> = ({ className: additionalClasses }) => {
  return (
    <div className={cx(styles.PoweredBy, additionalClasses)}>
      <p>Supercell</p>
      <div className={styles.PoweredByLogo}>
        <Image alt="logo" className={styles.Logo} src={SCLogo} layout="fill" objectFit="contain" />
      </div>
    </div>
  )
}
